import { Directive, ElementRef, Input, AfterViewInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appCalendarButtonTabindex]'
})
export class CalendarButtonTabindexDirective implements AfterViewInit {
  @Input('appCalendarButtonTabindex') tabindex = '0';

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngAfterViewInit() {
    // Set tabindex for all button elements inside p-calendar
    const buttons = this.el.nativeElement.querySelectorAll('button');
    buttons.forEach((btn: HTMLElement) => {
      this.renderer.setAttribute(btn, 'tabindex', this.tabindex);
    });
  }
}
